import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const DashboardActions = {
    getLastData(params) {
        dispatch({
            type  : AppConstants.DASHBOARD_LAST_START_LOADING
        });

        api.getReport(params)
            .then(data => {
                if (data.error) {
                    handleError(data, () => {
                        dispatch({
                            type: AppConstants.DASHBOARD_LAST_FAIL,
                            error: data.error
                        });
                    });
                    return;
                }
                
                dispatch({
                    type  : AppConstants.DASHBOARD_LAST_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type  : AppConstants.DASHBOARD_LAST_FAIL,
                        error : {
                            code: 0,
                            message: 'Unknown error'
                        }
                    });
                });
            });
    },

    getTodayData(params) {
        dispatch({
            type  : AppConstants.DASHBOARD_TODAY_START_LOADING
        });

        api.getReport(params)
            .then(data => {
                if (data.error) {
                    handleError(data, () => {
                        dispatch({
                            type: AppConstants.DASHBOARD_TODAY_FAIL,
                            error: data.error
                        });
                    });
                    return;
                }
                
                dispatch({
                    type  : AppConstants.DASHBOARD_TODAY_SUCCESS,
                    items : data.response || {}
                });
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type  : AppConstants.DASHBOARD_TODAY_FAIL,
                        error : {
                            code: 0,
                            message: 'Unknown error'
                        }
                    });
                });
            });
    }
};

export default DashboardActions;